import { createFragmentContainer, graphql } from 'react-relay';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';

import { isMobile } from '../../../utils/style';

import AsideMenu from '../asideMenu/AsideMenu';
import HeaderLogo from '../header/HeaderLogo';

import Candidate from '../../candidate/Candidate';

import SearchForm from '../../home/components/SearchForm';

import { Menu_query } from './__generated__/Menu_query.graphql';

const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;
`;

const Link = styled.span`
  cursor: pointer;
  align-self: center;
  font-size: 14px;
  color: #607389;
  margin-right: 10px;

  &:hover {
    color: rgba(96, 115, 137, 0.7);
    font-weight: semi-bold;
  }
`;

const MenuItemsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-start;
  padding: 0 30px;
`;

type Props = {
  query: Menu_query;
  onSearch: () => void;
  items: Record<string, unknown>[];
};
const Menu = ({ query, onSearch, items }: Props) => {
  const history = useHistory();
  const handleClick = (action: () => void, route: string) => {
    !!action && action();

    return history.push(route);
  };

  const { company, me } = query;

  return (
    <MenuWrapper>
      <AsideMenu
        onSearch={onSearch}
        items={items.filter((item) => !item.isDesktopOnly)}
      />
      <HeaderLogo company={company} logoRoute="public" />

      {!isMobile() && <SearchForm onSubmit={onSearch} />}

      {!isMobile() && (
        <MenuItemsWrapper>
          {items
            .filter((item) => !item.isMobileOnly)
            .map((item) => (
              <Link
                onClick={() => handleClick(item.action, item.route)}
                key={item.title}
              >
                {item.title}
              </Link>
            ))}
        </MenuItemsWrapper>
      )}
      <Candidate me={me} history={history} />
    </MenuWrapper>
  );
};

export default createFragmentContainer(Menu, {
  query: graphql`
    fragment Menu_query on Query {
      me {
        id
        ...Candidate_me
      }
      company: companyDomainName {
        id
        ...HeaderLogo_company
      }
    }
  `,
});
